import FiltersToDealershipTableForm from './FiltersToDealershipTableForm';

export default FiltersToDealershipTableForm;
